import CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/merge/merge';
import { GOSCRIPT_MODE } from '../goscript/goscript_mode';

import DiffMatchPatch from 'diff-match-patch';

if (!window.diff_match_patch) {
    window.diff_match_patch = DiffMatchPatch;
    window.DIFF_DELETE = -1;
    window.DIFF_INSERT = 1;
    window.DIFF_EQUAL = 0;
}

export const ApckGoScriptDiffModal = {
    props: {
        value: {
            type: String,
            default: '',
        },
        original: {
            type: String,
            default: '',
        },
        lineno: {
            type: Number,
            default: null,
        },
        column: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            codemirror: null,
        }
    },
    created () {
        CodeMirror.defineSimpleMode("goscript", GOSCRIPT_MODE);
    },
    beforeDestroy() {
        if (this.codemirror) {
            const wrapper = this.codemirror.wrap;
            if (wrapper && wrapper.parentNode) {
                wrapper.parentNode.removeChild(wrapper);
            }
            this.codemirror = null;
        }
    },
    mounted() {
        this.codemirror = CodeMirror.MergeView(this.$refs.codemirrorMerge, {
            origLeft: this.original,
            value: this.value,
            mode: 'goscript',
            lineNumbers: true,
            readOnly: true,
            lineWrapping: true,
            highlightDifferences: true,
            connect: 'align',
            collapseIdentical: false,
            allowEditingOriginals: false,
            revertButtons: false,
        });
        if (this.lineno) {
            this.$nextTick(() => {
                const editor = this.codemirror.editor();
                const line = this.lineno - 1;
                editor.focus();
                editor.setCursor({ line, ch: this.column });
                editor.addLineClass(line, 'background', 'code-editor-line-error');
                editor.scrollIntoView({ line, ch: this.column }, 200);
            });
        }
    },

    template: `
        <div class="codemirror-merge-wrapper">
            <div ref="codemirrorMerge"></div>
        </div>
    `,
};